import { render, staticRenderFns } from "./Bandeja.vue?vue&type=template&id=38c5643d&"
import script from "./Bandeja.vue?vue&type=script&lang=js&"
export * from "./Bandeja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports